import { FootprintDropdown } from '@lmn/lmn-components';
import styled from 'styled-components';
import { usePageWrapperData } from '@/app/common/pageWrapperProvider.tsx';
import { useFootprintExpanded } from '@/app/components/hotel-detail/hooks/useFootprintExpanded.ts';

const FootprintDropdownContainer = styled.div`
  background-color: white;
  border-radius: 8px;
`;

type Co2FootPrintProps = {
  co2Footprint: CO2Footprint;
} & React.HTMLAttributes<HTMLElement>;

export function Co2FootPrint(props: Co2FootPrintProps) {
  const { co2Footprint, ...rest } = props;
  const { localization } = usePageWrapperData();
  const footprintExpanded = useFootprintExpanded();
  return (
    <FootprintDropdownContainer ref={footprintExpanded.ref} {...rest}>
      <FootprintDropdown footprint={co2Footprint} locale={localization.locale} onToggle={footprintExpanded.onToggle} />
    </FootprintDropdownContainer>
  );
}
